import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { Linkedin, Instagram, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300 pt-16 pb-10 wsh-grain">
      <div className="container-x">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 border-t border-white/10 pt-12">
          <div className="col-span-2">
            <div className="flex items-baseline gap-1">
              <span className="font-display text-2xl text-stone-50">Wishire</span>
              <span className="font-display italic text-xs text-stone-400">.ai</span>
              <span className="ml-1 w-1.5 h-1.5 rounded-full bg-[#C2410C] inline-block translate-y-[-2px]" />
            </div>
            <p className="mt-3 text-stone-400 text-sm max-w-sm">
              India&apos;s AI-native placement platform — for colleges and the
              students they place.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <Social><Linkedin size={16} /></Social>
              <Social><Instagram size={16} /></Social>
              <Social><Twitter size={16} /></Social>
            </div>
          </div>

          <FooterCol
            title="Product"
            links={[["For colleges", "/for-colleges"], ["For students", "/for-students"], ["For recruiters", "/for-recruiters"], ["Wishire Score", "/guides/placement-readiness-score-explained"], ["Pricing", "/pricing"]]}
          />
          <FooterCol
            title="Company"
            links={[["About", "/about"], ["Wishire vs Superset", "/compare/wishire-vs-superset"], ["Book a demo", "/#book-demo"], ["Log in", "/login"]]}
          />
          <FooterCol
            title="Resources"
            links={[["Guides", "/guides"], ["Company test patterns", "/company-tests"], ["TCS NQT mock", "/company-tests/tcs-nqt"], ["Improve placement rate", "/guides/how-to-improve-campus-placement-rate"], ["ATS résumé for freshers", "/guides/ats-resume-for-freshers"]]}
          />
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-stone-500 font-mono uppercase tracking-widest">
          <p>© {new Date().getFullYear()} Wishire Technologies Pvt. Ltd.</p>
          <LegalLinks />
        </div>
      </div>
    </footer>
  );
}

function LegalLinks() {
  const [pages, setPages] = useState([]);
  useEffect(() => { apiClient.get("/pages").then(({ data }) => setPages(data.pages || [])).catch(() => {}); }, []);
  if (pages.length === 0) return <p>Responsible AI</p>;
  return (
    <p className="flex flex-wrap gap-x-2">
      {pages.map((p, i) => (
        <span key={p.slug}>
          {i > 0 && <span className="mr-2">·</span>}
          <a href={`/p/${p.slug}`} className="hover:text-stone-300 transition-colors">{p.title}</a>
        </span>
      ))}
    </p>
  );
}

function Social({ children }) {
  return (
    <a
      href="#"
      className="w-9 h-9 rounded-full border border-white/20 text-stone-300 hover:text-stone-900 hover:bg-amber-300 hover:border-amber-300 transition-colors inline-flex items-center justify-center"
    >
      {children}
    </a>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="overline" style={{ color: "rgba(253,251,247,0.55)" }}>
        {title}
      </p>
      <ul className="mt-4 space-y-3">
        {links.map((l) => {
          const [label, href] = Array.isArray(l) ? l : [l, "#"];
          return (
            <li key={label}>
              <a href={href} className="text-stone-300 hover:text-stone-50 text-sm transition-colors">
                {label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
